import { render, staticRenderFns } from "./AlarmPage.vue?vue&type=template&id=052a3cd8&scoped=true&"
import script from "./AlarmPage.vue?vue&type=script&lang=js&"
export * from "./AlarmPage.vue?vue&type=script&lang=js&"
import style0 from "./AlarmPage.vue?vue&type=style&index=0&id=052a3cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a3cd8",
  null
  
)

export default component.exports